module.exports = __webpack_public_path__ + "static/images/components/ModernizationOverlay/images/modernization-bg-75.29f63e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/ModernizationOverlay/images/modernization-bg-75.jpg
// module id = 2611
// module chunks = 11